export class MultiError extends Error {
  errors: string[] = [];
  
  constructor(errors: string[], ...params: any[]) {
    super(...params);
    this.name = 'MultiError';
    this.errors = errors;
  }
}
